'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  var mentions = [];
  var mentionOrList = void 0;
  var mentionsOrLists = (0, _extractMentionsOrListsWithIndices2.default)(text);

  for (var i = 0; i < mentionsOrLists.length; i++) {
    mentionOrList = mentionsOrLists[i];
    if (mentionOrList.listSlug === '') {
      mentions.push({
        screenName: mentionOrList.screenName,
        indices: mentionOrList.indices
      });
    }
  }

  return mentions;
};

var _extractMentionsOrListsWithIndices = require('./extractMentionsOrListsWithIndices');

var _extractMentionsOrListsWithIndices2 = _interopRequireDefault(_extractMentionsOrListsWithIndices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];